import AllAccessIcon from 'images/subscribe-icon-all-access.svg';
import MonthlyIcon from 'images/subscribe-icon-monthly.svg';
import YpIcon from 'images/subscribe-icon-yp.svg';

import { ButtonProps } from '../components/BaseUI/Button';
import { subscribe_path } from '../routes';
import {
  DEFAULT_ALL_ACCESS_PRICE,
  DEFAULT_ANNUAL_PRICE,
  DEFAULT_MONTHLY_PRICE,
  DEFAULT_PRO_PRICE,
  YOUNG_PROFESSIONALS_PRICE,
} from './backend-api/subscribe';

const MONTHLY_OFFER_CODE = 'now_monthly';
const ANNUAL_OFFER_CODE = 'now_annual';
const ALL_ACCESS_OFFER_CODE = 'now_all_access';
const YOUNG_PROFESSIONALS_PLAN = 'yp';
const PRO_OFFER_CODE = 'now_pro';

export type planType =
  | 'basic'
  | 'monthly'
  | 'annual'
  | 'professional'
  | 'all_access'
  | 'young_professionals';

interface GenerateCardPropArgs {
  planType: planType;
  hrefParams?: { [key: string]: string };
  trackingProps?: { [key: string]: string };
}

export const generateCardProps = ({
  planType,
  hrefParams = {},
  trackingProps = {},
}: GenerateCardPropArgs) => {
  const buttonProps: ButtonProps = {
    rounded: 'full' as const,
    href: '', // assign this based on planType in switch statement below
    trackClick: Object.keys(trackingProps).length > 0,
    trackingProps,
  };
  let benefits: string[] = [];
  let icon: string;
  let price: number;
  let title: string;
  let altTitle: string;

  switch (planType) {
    case 'monthly':
    case 'basic':
      buttonProps.href = subscribe_path({ offer: MONTHLY_OFFER_CODE, ...hrefParams });
      benefits = [
        'Unlimited access to reporting',
        'Access to Profiles, Directory and Forum',
        'No access to org charts',
      ];
      icon = MonthlyIcon;
      price = DEFAULT_MONTHLY_PRICE;
      title = 'Monthly';

      if (planType === 'basic') {
        altTitle = 'Basic';
      }
      break;
    case 'annual':
      buttonProps.href = subscribe_path({ offer: ANNUAL_OFFER_CODE, ...hrefParams });
      benefits = [
        "Read stories you won't find elsewhere",
        'Subscribe to our suite of newsletters',
        'Access to Profiles, Directory and Forum',
        'Access our exclusive company org chart library',
        'Read on the go with The Information app',
      ];
      icon = AllAccessIcon;
      price = DEFAULT_ANNUAL_PRICE;
      title = 'Annual';

      break;
    case 'all_access':
      buttonProps.href = subscribe_path({ offer: ALL_ACCESS_OFFER_CODE, ...hrefParams });
      benefits = [
        'Everything included in our Professional subscription',
        '<span class="--red">A free VIP ticket to most events</span>',
      ];
      icon = AllAccessIcon;
      price = DEFAULT_ALL_ACCESS_PRICE;
      title = 'All Access';

      break;
    case 'young_professionals':
      buttonProps.href = subscribe_path({ plan: YOUNG_PROFESSIONALS_PLAN, ...hrefParams });
      benefits = [
        'Available for those 30 and under',
        'Same access as Professional',
        'Receive <span class="--red">five years of Professional access</span> at our best price',
      ];
      icon = YpIcon;
      price = YOUNG_PROFESSIONALS_PRICE;
      title = 'Young Professionals';
      break;
    case 'professional':
      buttonProps.href = subscribe_path({ offer: PRO_OFFER_CODE, ...hrefParams });
      benefits = [
        "Read stories you won't find elsewhere",
        'Subscribe to our suite of newsletters',
        'Access to Profiles, Directory and Forum',
        'Access our exclusive company org chart library',
        'Read on the go with The Information app',
      ];
      icon = AllAccessIcon;
      price = DEFAULT_PRO_PRICE;
      title = 'Professional';
      altTitle = 'The Information Pro';

      break;
  }

  return {
    altTitle,
    benefits,
    buttonProps,
    icon,
    price,
    title,
  };
};
